const arrayGetSplice = <T>( ts:T[], start:number, deleteCount:number, ...t:T[] ) : T[] => {
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/toSpliced
    ts.splice(start,deleteCount,...t);
    return ts;
}

export default arrayGetSplice;
